export const TriggerEvents = [
  { label: 'New Widget Signup', value: 'signupEvent' },
];

export const CampaignModal = Object.freeze({
  GenCampagian: 'generalcampaign',
  TriggerCampaign: 'triggercampaign',
});
export const CampaignFormType = Object.freeze({
  Add: 'add',
  Edit: 'edit',
  Replicate: 'replicate',
  // legacy alias kept for existing imports
  replicateCampagian: 'replicate',
});

export const CAMPAIGN_TYPES = Object.freeze({
  General: 'General',
  Trigger: 'Trigger',
});

/**
 * Map stored trigger event values to react-select options.
 * @param {string[]} events
 * @returns {{label: string, value: string}[]}
 */
export function mapTriggerEventOptions(events = []) {
  if (!Array.isArray(events)) {
    return [];
  }
  return events.map((tag) => {
    const match = TriggerEvents.find((event) => event.value === tag);
    return {
      label: (match && match.label) || tag,
      value: tag,
    };
  });
}

/**
 * Build create-form values for a replicated campaign.
 * Treats replicate as a new Draft prefilled from the source; does not copy schedule/send timing.
 * Preserves tags, trigger flag/events, referral opt-in, and URL shortening from the source.
 *
 * @param {object} campaign - Source campaign from GET_CAMPAIGN
 * @param {{ referralText: string, unsubscribeFallback?: string, draftStatus: string }} options
 * @returns {object}
 */
export function buildReplicateInitialValues(campaign, options) {
  const referralText = options.referralText || '';
  const draftStatus = options.draftStatus;
  const tags = Array.isArray(campaign.tags) ? campaign.tags : [];
  const events = Array.isArray(campaign.events) ? campaign.events : [];

  return {
    name: `${campaign.name} (copy)`,
    text: campaign.text || '',
    unsubscribeMessage: campaign.unsubscribeMessage || options.unsubscribeFallback || '',
    status: draftStatus,
    type: campaign.type || 'SMS',
    dateTime: null,
    imageUrl: campaign.imageUrl || '',
    referralOptIn: !!campaign.referralOptIn,
    referralOptInText: referralText || campaign.referralOptInText || '',
    isUrlShortningEnabled: campaign.isUrlShortningEnabled !== false,
    tags,
    isTriggerCampaign: !!campaign.isTriggerCampaign,
    events,
  };
}
